import { isDirectCompareItemUrl } from "./directCompareUrl";

export interface SpecifiedCompareItem extends Record<string, unknown> {
  item_id?: string | number;
  item_title?: string;
  memo?: string;
  item_price?: number | null;
  item_price_on_page?: number | null;
  item_discount?: number | null;
  item_discount_by_market?: number | null;
  dest_url?: string;
  item_url?: string;
  url?: string;
  updated_at?: string;
}

export const parseSpecifiedCompareItems = (value: unknown): SpecifiedCompareItem[] => {
  if (Array.isArray(value)) {
    return value.filter(
      (item): item is SpecifiedCompareItem => typeof item === "object" && item !== null,
    );
  }

  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  return [];
};

export const buildInitialDirectSpecifiedItems = (
  portalValue: unknown,
  directValue: unknown,
): SpecifiedCompareItem[] => {
  const directItems = parseSpecifiedCompareItems(directValue);
  if (directItems.length > 0) return directItems;

  const seenUrls = new Set<string>();
  return parseSpecifiedCompareItems(portalValue).flatMap((row) => {
    const itemUrl = String(row.item_url || "").trim();
    if (!isDirectCompareItemUrl(itemUrl) || seenUrls.has(itemUrl)) return [];
    seenUrls.add(itemUrl);
    return [{ ...row, item_id: itemUrl, item_url: itemUrl }];
  });
};
